// ─── 오늘 시간별 막대 차트 (3시간 단위) ─────────────────────────────────────
import React, { useState } from 'react';
import { todayStr } from '../../utils/formatters';

export default function HourlyBars({ rows }) {
  const [hov, setHov] = useState(null);

  const td        = todayStr();
  const todayRows = rows.filter((r) => r.chat_time?.slice(0, 10) === td);

  const buckets = Array.from({ length: 8 }, (_, i) => {
    const from = i * 3;
    const to   = from + 3;
    const n    = todayRows.filter((r) => {
      if (!r.chat_time) return false;
      const h = new Date(r.chat_time).getHours();
      return h >= from && h < to;
    }).length;
    return { from, to, n, label: `${from}시` };
  });

  const maxN = Math.max(...buckets.map((b) => b.n), 1);

  return (
    <div className="flex flex-col gap-2">
      {/* 막대 영역 */}
      <div className="flex items-end gap-2" style={{ height: '110px' }}>
        {buckets.map((b, i) => {
          const pct   = b.n > 0 ? Math.max((b.n / maxN) * 100, 6) : 0;
          const isHov = hov === i;
          return (
            <div
              key={i}
              className="relative flex-1 flex flex-col justify-end"
              style={{ height: '100%' }}
              onMouseEnter={() => setHov(i)}
              onMouseLeave={() => setHov(null)}
            >
              {/* 수치 레이블 */}
              {b.n > 0 && (
                <div className="text-center text-xs font-semibold text-gray-500 mb-1">
                  {b.n}
                </div>
              )}
              {/* 툴팁 */}
              {isHov && b.n > 0 && (
                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs font-semibold text-white z-10">
                  {b.from}~{b.to}시 · {b.n}건
                </div>
              )}
              {/* 막대 */}
              <div
                className="w-full rounded-t-md transition-colors"
                style={{
                  height: `${pct}%`,
                  minHeight: b.n > 0 ? '6px' : '0',
                  backgroundColor: b.n === 0
                    ? 'transparent'
                    : isHov ? '#2563eb' : '#93c5fd',
                }}
              />
            </div>
          );
        })}
      </div>

      {/* X축 기준선 */}
      <div className="border-t border-gray-200" />

      {/* X축 레이블 */}
      <div className="flex">
        {buckets.map((b, i) => (
          <div key={i} className="flex-1 text-center">
            <span className="text-xs text-gray-400">{b.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
